// Shared MUI DataGrid styling for every list page in the admin.
//
// Each page used to carry its own near-identical `sx` block, which is why the
// tables had drifted apart. They now import this one so a change lands
// everywhere at once.
//
// The grid deliberately has no border, radius or shadow of its own: it sits
// directly on the shell's white panel, and rows are separated by hairlines
// rather than being cards.
const gridSx = {
  border: "none",
  boxShadow: "none",
  padding: 0,
  width: "100%",

  "& .MuiDataGrid-main": {
    overflowY: "overlay",
  },

  // Column labels are small muted caps so player and team names are the only
  // strong text in the table.
  "& .MuiDataGrid-columnHeaders": {
    borderBottom: "1px solid #eff0f6",
    "& .MuiDataGrid-columnHeadersInner": {
      backgroundColor: "transparent",
      "& .MuiDataGrid-columnSeparator": { display: "none" },
      "& .MuiDataGrid-columnHeaderTitle": {
        fontFamily: "IBMPlexSans-SemiBold",
        color: "#a098ae",
        fontSize: "11px",
        letterSpacing: "1.2px",
        textTransform: "uppercase",
      },
    },
  },

  "& .MuiDataGrid-row": {
    background: "#fff !important",
    transition: "0.15s ease",
    "&:hover": { background: "#fafbfd !important" },
  },

  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #eff0f6",
    fontFamily: "IBMPlexSans-Medium",
    fontSize: "13px",
    color: "#363b64",
    "&:focus, &:focus-within": { outline: "none" },
  },

  "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
    {
      outline: "none",
    },

  "& .MuiCheckbox-root": { color: "#dbdbdb !important" },
  "& .MuiCheckbox-root.Mui-checked": { color: "#0040a8 !important" },

  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #eff0f6",
    "& .MuiTablePagination-root": {
      fontFamily: "IBMPlexSans-Regular",
      fontSize: "12px",
      color: "#a098ae",
    },
  },

  "& .MuiDataGrid-virtualScroller": { overflowX: "auto" },
  "& .MuiDataGrid-overlay": {
    fontFamily: "IBMPlexSans-Regular",
    color: "#a098ae",
  },
};

export default gridSx;
